import {Authorization} from './';
import axios from 'axios';
import {APIURL} from '../constants';
export const UsersAuthorization = {
	authorize : function(to, next, success, error)
	{
		switch(to)
		{
			default:
				Authorization.isAdmin(
					(isAdmin) => {

						if(!success)
						{
							defaultSuccess(isAdmin, next);
						} else {
							success(isAdmin)
						}
						
					},
					(err) => {
						if(!error)
						{
							defaultError(next);
						}
						else {
							error(err);
						}
					}
				)
			break;
		}
	},

	exists : function(to){
		return axios.get(APIURL + 'users/show/' + to.params.id)
	}
};

const defaultSuccess = function(isAuthorized, next)
{

	if(isAuthorized)
	{
		next()
	} else {
		next({name: 'home'})
	}
};

const defaultError = function(next)
{
	next(false);
}